// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__vmW8h","select":"Header_select__223f0","clinic":"Header_clinic__2Frce"};